module.exports = __webpack_public_path__ + "img/chess-bishop.005aac21.svg";